import { useFormik } from "formik";
import * as Yup from "yup";
import { RiErrorWarningLine } from "react-icons/ri";
import { GrCircleQuestion } from "react-icons/gr";
import ModalInfo from "../../../components/lib/modalInfo";
import CustomButton from "../../../components/lib/customButton";

const EmployeeEditForm = ({ isOpen, employee, onClose, onSubmit, onDirty, hideFooter = false }) => {
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: employee?.name || "",
            email: employee?.email || "",
            phone_number: employee?.phone_number || "",
            emergency_value: employee?.emergency_value ?? 0.0,
            spend_limit: employee?.spend_limit ?? 0.0,
        },
        validationSchema: Yup.object({
            name: Yup.string()
                .required("Nome é um campo obrigatório")
                .max(50, "O nome deve ter no máximo 50 caracteres")
                .test(
                    "two-words",
                    "O nome deve ser completo, formado por mais de uma palavra.",
                    (value) => value && value.trim().split(/\s+/).length >= 2
                ),
            email: Yup.string().email("Email inválido"),
        }),
        onSubmit: async (values) => {
            try {
                await onSubmit({ ...employee, ...values, client_code: employee.client_code });
            } catch (e) {
            }
        },
    });

    return (
        <form data-step-form onSubmit={formik.handleSubmit} className="flex flex-col gap-4" onChange={onDirty}>
            {/* NOME */}
            <label>
                <div className="flex items-center justify-between">
                    <p>Nome</p>
                    <ModalInfo icon={<RiErrorWarningLine />} content="Campo Obrigatório!" />
                </div>
                <input
                    className={`block w-full px-3 py-1.5 border rounded ${formik.touched.name && formik.errors.name ? "border-red-500" : "border-gray-300"}`}
                    name="name"
                    type="text"
                    onChange={(e) => { onDirty(); formik.handleChange(e); }}
                    onBlur={formik.handleBlur}
                    value={formik.values.name}
                />
                {formik.touched.name && formik.errors.name && (
                    <p className="text-red-500 text-xs">{formik.errors.name}</p>
                )}
            </label>

            {/* EMAIL / TELEFONE */}
            <div className="grid grid-cols-2 gap-4 my-2">
                <label>
                    <p>Email</p>
                    <input
                        className="block w-full px-3 py-1.5 border rounded"
                        name="email"
                        type="text"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.email}
                    />
                </label>

                <label>
                    <p>Telefone</p>
                    <input
                        className="block w-full px-3 py-1.5 border rounded"
                        name="phone_number"
                        type="text"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.phone_number}
                    />
                </label>
            </div>

            {/* LIMITES */}
            <div className="grid grid-cols-2 gap-4 my-2">
                <label>
                    <div className="flex items-center justify-between">
                        <p>Valor de Emergência</p>
                        <ModalInfo icon={<GrCircleQuestion />} content="Valor negativo máximo permitido." />
                    </div>
                    <input
                        className="block w-full px-3 py-1.5 border rounded"
                        name="emergency_value"
                        type="number"
                        step="0.05"
                        onChange={formik.handleChange}
                        value={formik.values.emergency_value}
                    />
                </label>

                <label>
                    <div className="flex items-center justify-between">
                        <p>Limite de gastos diário</p>
                        <ModalInfo icon={<GrCircleQuestion />} content="Limite diário de consumo." />
                    </div>
                    <input
                        className="block w-full px-3 py-1.5 border rounded"
                        name="spend_limit"
                        type="number"
                        step="0.05"
                        onChange={formik.handleChange}
                        value={formik.values.spend_limit}
                    />
                </label>
            </div>

            {/* Footer */}
            {!hideFooter && (
                <div className="mt-2 flex justify-end gap-3">
                    <CustomButton
                        buttonType="save"
                        text="Salvar"
                        onClick={() => { }}
                        fullWidth
                    />
                    <CustomButton
                        buttonType="cancel"
                        type="button"
                        text="Cancelar"
                        onClick={onClose}
                        fullWidth
                    />
                </div>
            )}
        </form>
    );
};

export default EmployeeEditForm;